import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import classnames from 'classnames/bind';
import style from './index.module.scss';
import VehicleSelection from '../VehicleSelection';
import OilSelection from '../../../OilSelection';
import LocationSelection from '../../../LocationSelection';
import {
  ICoordinate,
  ICountry,
  IOilFilter,
  IProductCategory,
  IState,
  IVehicle,
  ProductCategory,
  Replacement,
} from '../../../../interface';
import {Dispatch} from 'redux';
import actions from '../../../../redux/actions';
import FindTheRightOil from '../../FindTheRightOil';
import {isOnlyWTBcountry} from '../../../../utils/isOnlyWTBcountry';
import {useSearchParams} from 'react-router-dom';
import {useAppName} from '../../../../hooks/use-app-names';
import {APPNAME, FASTSCAN} from '../../../../constants';
import localesReplacement from '../../../../utils/localesReplacement';
import moment from 'moment';
import {useMediaQuery} from 'react-responsive';

const cx = classnames.bind(style);

interface IProps extends IOilFilter {
  replacements: Replacement;
  setOverlay: (value: boolean) => void;
  setProductCategories: (value: string[]) => void;
  setVehicle: (value: IVehicle | undefined) => void;
  position: ICoordinate;
  productCategoriesList: ProductCategory[] | null;
  country: ICountry;
  filter: IOilFilter;
  isMiles: boolean;
}

//Top filter for vehicle selection & product categories & product recommendations & manual location
function FilterSection(props: IProps) {
  const {
    productCategories,
    replacements,
    setOverlay,
    vehicle,
    setProductCategories,
    setVehicle,
    position,
    productCategoriesList,
    country: currentCountry,
    filter,
    isMiles
  } = props;
  const isDesktopOrLaptop = useMediaQuery({minWidth: 1024});
  const isFastScan = useAppName(FASTSCAN);
  const [searchParams, setSearchParams] = useSearchParams();
  const i18n = localStorage.getItem('languageCode') as string;
  const country = (localStorage.getItem('countryCode') ||
    process.env.REACT_APP_COUNTRYCODE) as string;
  const [productCategoriesDrop, setProductCategoriesDrop] = useState<
    IProductCategory[]
  >([]);
  const [searchVisible, setSearchVisible] = useState(false);
  //set product categories & product recommendations when vehicle selection drodown is selected
  useEffect(() => {
    setProductCategoriesDrop([]);
    productCategoriesList
      ? setProductCategoriesDrop(
          //eslint-disable-next-line
          _.map(productCategoriesList, (o: any) => {
            return _.includes(productCategories, _.toString(o['id']))
              ? {...o, checked: true}
              : {...o, checked: false};
          }),
        )
      : setProductCategoriesDrop([]);
  }, [vehicle, productCategoriesList]);
  //Change the product categories dropdown
  const changeLubricants = (value: IProductCategory) => {
    setProductCategoriesDrop(
      _.unionBy([...productCategoriesDrop, value], 'id'),
    );
    setProductCategories(
      _.chain([...productCategoriesDrop, value])
        .uniqBy('id')
        .filter('checked')
        .orderBy('id')
        .map((d) => _.toString(d['id']))
        .value(),
    );
  };
  const selectVehicleHandle = (value: string | number) => {
    searchParams.set('page', 'recommendedProducts');
    searchParams.set('id', _.toString(value));
    isFastScan && searchParams.set(APPNAME, FASTSCAN);
    setSearchParams(searchParams);
    setSearchVisible(false);
  };
  const selectProductHandle = (value: string | number) => {
    searchParams.set('page', 'product');
    searchParams.set('id', _.toString(value));
    isFastScan && searchParams.set(APPNAME, FASTSCAN);
    setSearchParams(searchParams);
    setSearchVisible(false);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([e]) => e.target.toggleAttribute('stuck', e.intersectionRatio < 1),
      {threshold: [1]},
    );

    observer.observe(document.querySelector('#stuck-element') as Element);
  }, []);

  const [mode, setMode] = useState<boolean>(
    sessionStorage.getItem('selectedType') === 'true' ? true : false,
  );

  return (
    <>
      <div id='stuck-element' className={cx('filter-section')}>
        <div className={cx('inner')}>
          {/* vehicle selection dropdown */}
          <div className={cx('block', 'vehicle')}>
            <VehicleSelection
              setVehicle={setVehicle}
              disabled={isOnlyWTBcountry(currentCountry.isoCode)}
              clickHandler={() => setSearchVisible(true)}
            />
          </div>
          <div className={cx('filter-bar')} onClick={() => setOverlay(true)}>
            <div>
              <strong>{localesReplacement(replacements, 'Opening Hours')}:</strong>
              {filter.openHours
                ? moment().hours(filter.openHours).minute(0).format('kk:mm')
                : 'null'}{' '}
              -{' '}
              {filter.closeHours
                ? moment().hours(filter.closeHours).minute(0).format('kk:mm')
                : 'null'}
              , <strong>{localesReplacement(replacements, 'Distance')}:</strong>
              {filter.distance} {isMiles ? 'mil' : 'km'}
            </div>
          </div>
          {/* vehicle product categories dropdown */}
          <div className={cx('block', 'oil')}>
            <OilSelection
              dataList={productCategoriesDrop}
              type='category'
              onChangeHandler={changeLubricants}
            />
          </div>
          {/* manual location autocomplete */}
          <div className={cx('block', 'location')}>
            <LocationSelection position={position} />
          </div>
        </div>
        {/* trigget the flyout on mobile */}
        <span
          className={`button ${cx('filter-list')}`}
          onClick={() => setOverlay(true)}
          role='button'
        ></span>
      </div>

      {searchVisible && !isDesktopOrLaptop && (
        <div className={cx('findTheOil')}>
          <div
            className={cx('mask')}
            onClick={() => setSearchVisible(false)}
          ></div>
          <div className={`as-modal ${cx('flyout')}`}>
            <FindTheRightOil
              country={country}
              onVehicleSelect={(value) => selectVehicleHandle(value)}
              onProductSelect={(value) => selectProductHandle(value)}
              i18n={i18n}
              locales={replacements}
              baseAPI={process.env.REACT_APP_PROVIDER_URL}
              restore={isFastScan}
              mode={mode}
              setMode={setMode}
            />
          </div>
        </div>
      )}
    </>
  );
}

const mapStateToProps = (state: IState) => ({
  vehicle: state.filter.vehicle,
  productCategories: state.filter.productCategories,
  productCategoriesList: state.productCategoriesList,
  country: state.country,
  filter: state.filter,
  isMiles: state.isMiles  
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setProductCategories: (productCatgories: string[]) =>
    dispatch(actions.setProductCategories(productCatgories)),
  setVehicle: (vehicle: IVehicle | undefined) =>
    dispatch(actions.setVehicle(vehicle)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FilterSection);
